import { useCallback, useEffect, useState } from 'react';

/**
 * Навешивает на блок события для отслеживания состояния наведения мышкой - как hover в css
 *
 * @deprecated `Используй propsHooks/useHovered` т.к. это более оптимально с точки зрения производительности.
 */
export const useHovered = (element: HTMLElement | null) => {
  const [hovered, setHovered] = useState<boolean>(false);

  const onMouseEnterHandler = useCallback(() => {
    setHovered(true);
  }, []);
  const onMouseLeaveHandler = useCallback(() => {
    setHovered(false);
  }, []);

  useEffect(() => {
    if (!element) {
      return;
    }

    element.addEventListener('mouseenter', onMouseEnterHandler);
    element.addEventListener('mouseleave', onMouseLeaveHandler);

    return () => {
      if (element) {
        element.removeEventListener('mouseenter', onMouseEnterHandler);
        element.removeEventListener('mouseleave', onMouseLeaveHandler);
      }
    };
  }, [element, onMouseEnterHandler, onMouseLeaveHandler]);

  return hovered;
};
